<template>
  <span id="NavBar">
    <transition name="fade">
      <div class="bar-container">
        <div v-show="showSubNav" class="sub-bar">
          <ul class="sub-list-wrapper" :class="{'fourth-nav-list': subNavCount === 'fourthPart'}">
            <li v-for="nav in subNav" :key="nav.label" class="sub-nav" @click="$router.push(nav.route)">{{ nav.label }}</li>
          </ul>
          <span class="nav-arrow" :class="{'fourth-sub': subNavCount === 'fourthPart'}"/>
        </div>
        <div class="bar">
          <router-link tag="div" to="/Start"/>
          <div @click="getSubNav('secondPart')"/>
          <router-link tag="div" to="/TitlePage/02"/>
          <router-link tag="div" to="/TitlePage/03"/>
          <div @click="getSubNav('fourthPart')"/>
          <router-link tag="div" to="/TitlePage/05"/>
          <router-link tag="div" to="/End"/>
        </div>
      </div>
    </transition>
  </span>
</template>

<script>
const subNav = {
  secondPart: [
    { label: '封面', route: '/TitlePage/01' },
    { label: '大事记', route: { name: 'Nav' }},
    { label: '三维透视', route: { name: 'Island', query: { step: 0 }}},
    { label: '快速筑岛', route: { name: 'Island', query: { step: 1 }}},
    { label: '沉管建造', route: { name: 'Tunnel', query: { step: 0 }}},
    { label: '浮运安装', route: { name: 'Tunnel', query: { step: 1 }}},
    { label: '对接体验', route: { name: 'Tunnel', query: { step: 2 }}},
    { label: '桥墩安装', route: { name: 'Bridge', query: { step: 0 }}},
    { label: '桥面吊装', route: { name: 'Bridge', query: { step: 1 }}},
    { label: '钢塔吊装', route: { name: 'Bridge', query: { step: 2 }}},
    { label: '桥面铺装', route: { name: 'Bridge', query: { step: 3 }}},
    { label: '全线亮灯', route: { name: 'Bridge', query: { step: 4 }}},
  ],
  fourthPart: [
    { label: '封面', route: '/TitlePage/04' },
    { label: '建设者代表', route: '/Part04/Representative' },
    { label: '建设者影像', route: '/Part04/Portrait' },
    { label: '建设单位名录', route: '/Part04/Institution' },
  ],
}
export default {
  name: 'NavBar',
  data () {
    return {
      showBar: false,
      showFrame: false,
      subNav: [],
      subNavCount: '',
      showSubNav: false,
    }
  },
  watch: {
    '$route.fullPath' () {
      this.showSubNav = false
      this.subNavCount = ''
    },
  },
  methods: {
    getSubNav (flag) {
      if (this.subNavCount === flag) {
        this.subNavCount = ''
        this.showSubNav = false
      } else {
        this.subNavCount = flag
        this.subNav = subNav[flag]
        this.showSubNav = true
      }
    },
    hideSubNav () {
      this.showSubNav = false
    },
  },
}
</script>
<style lang="scss" scoped>
#NavBar {
  position: absolute;
  right: 0;
  bottom: 0.05rem;
  left: 0;
  margin: 0 auto;
  width: 9.3rem;
  height: 0.8rem;
  font-size: 0;
  z-index: 101;
  .bar-container {
    height: 100%;
    .sub-bar {
      position: absolute;
      top: -0.5rem;
      height: 0.5rem;
      width: 100%;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
      background-color: #204c85;
      .sub-list-wrapper {
        width: 100%;
        height: 100%;
        font-size: 0.16rem;
        line-height: 0.5rem;
        .sub-nav {
          display: inline-block;
          margin: 0 0.07rem;
          color: #fff;
          cursor: pointer;
          &:first-child {
            margin-left: 0.2rem;
          }
          &:hover {
            color: #f5db6b;
          }
        }
        &.fourth-nav-list {
          .sub-nav {
            &:first-child {
              margin-left: 5.6rem;
            }
          }
        }
      }
      .nav-arrow {
        position: absolute;
        width: 0;
        height: 0;
        left: 1.7rem;
        top: 0.5rem;
        border: .13rem solid #496d9b;
        z-index: 1000;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        &.fourth-sub {
          left: 5.9rem;
        }
      }
    }
    .bar {
      height: 100%;
      border-radius: 10px;
      background-image: url(../assets/img/navbar/nav-bar.png);
      background-size: 100% 100%;
      box-shadow: 0px 0px 5px 1px #638cba;
      & > div {
        display: inline-block;
        width: 1.42rem;
        height: 100%;
        z-index: 1;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1.18rem 0.58rem;
        transition: all 0.3s ease-out;
        &:first-child,
        &:last-child {
          width: 1.1rem;
          background-size: 0.6rem 0.33rem;
        }
        &:hover {
          transform: scale(1.05);
        }
      }
      & > div:nth-child(1) {
        background-image: url(../assets/img/navbar/icon-word.png);
        &:hover {
          background-image: url(../assets/img/navbar/icon-word-active.png);
        }
      }
      & > div:nth-child(2) {
        background-image: url(../assets/img/navbar/first-part.png);
        &:hover {
          background-image: url(../assets/img/navbar/first-part-active.png);
        }
      }
      & > div:nth-child(3) {
        background-image: url(../assets/img/navbar/second-part.png);
        &:hover {
          background-image:  url(../assets/img/navbar/second-part-active.png);
        }
      }
      & > div:nth-child(4) {
        background-image: url(../assets/img/navbar/three-part.png);
        &:hover {
          background-image: url(../assets/img/navbar/three-part-active.png);
        }
      }
      & > div:nth-child(5) {
        background-image: url(../assets/img/navbar/four-part.png);
        &:hover {
          background-image: url(../assets/img/navbar/four-part-active.png);
        }
      }
      & > div:nth-child(6) {
        background-image: url(../assets/img/navbar/five-part.png);
        &:hover {
          background-image: url(../assets/img/navbar/five-part-active.png);
        }
      }
      & > div:nth-child(7) {
        background-image: url(../assets/img/navbar/last.png);
        &:hover {
          background-image: url(../assets/img/navbar/last-active.png);
        }
      }
    }
  }
}
</style>
